import { createCustomSearchParamsUpdater } from '@gonfalon/router/createCustomSearchParamsUpdater';

import { parseChangehistorySearchParams } from './parseChangehistorySearchParams';
import { serializeChangehistorySearchParams } from './serializeChangehistorySearchParams';

export const changeHistorySearchParamsUpdater = createCustomSearchParamsUpdater({
  parse: parseChangehistorySearchParams,
  serialize: serializeChangehistorySearchParams,
});
